import React from 'react';
import InfoCard from './InfoCard.js';

const Heading = ({ header, cards, topView, pro }) => (
  <div className="autzu-fleets-why-drive__container">
    <div className="autzu-fleets-why-drive__content--desktop">
      <div className="autzu-fleets-why-drive__column">
        <h2> {header}</h2>
        <div className="autzu-fleets-why-drive__column--sub">
          <div className={`autzu-fleets-why-drive__vehicle--${pro ? 'pro' : 'plus'}`}>{topView}</div>
          <div className="autzu-fleets-why-drive__column--card">
            <InfoCard cardContent={cards[0]} />
            <InfoCard cardContent={cards[1]} />
          </div>
        </div>
      </div>
      <div className="autzu-fleets-why-drive__column">
        <div className="autzu-fleets-why-drive__column--card">
          <InfoCard cardContent={cards[2]} />
          <InfoCard cardContent={cards[3]} />
        </div>
      </div>
    </div>
    <div className="autzu-fleets-why-drive__content--mobile">
      <div className="autzu-fleets-why-drive__column">
        <h2> {header}</h2>
        <InfoCard cardContent={cards[0]} />
        <InfoCard cardContent={cards[1]} />
        <InfoCard cardContent={cards[2]} />
        <InfoCard cardContent={cards[3]} />
      </div>
    </div>
  </div>
);

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Static/TorontoFleets/Shared/WhyDrive.js